<template>
  <v-container fluid class="px-0">
    <v-row class="mb-3">
      <v-col cols="12" md="6">
        <el-text-field
          need
          label="Identifikacijos numeris"
          tooltip="Hipoteka. Turtas. Riedmuo. Identifikacijos numeris"
          :counter="10"
          :readonly="turtasReadonly || !sudarymas"
          v-model="formData.tur_identifikatorius"
          :autofocus="!turtasReadonly && sudarymas"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-date-picker
          need
          label="Pagaminimo data"
          tooltip="Hipoteka. Turtas. Riedmuo. Pagaminimo data"
          :readonly="turtasReadonly"
          v-model="formData.tur_vagonas_pagaminimo_data"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TurtasVagonas',
  props: {
    formData: Object,
    readonly: Boolean,
    irasomas: Boolean,
    sudarymas: Boolean,
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    turtasReadonly() {
      return this.readonly || !this.irasomas
    },
  },
}
</script>
